import React from "react"
import RoomTypeBuilderGeneral from "./tabs/RoomTypeBuilderGeneral"
import RoomTypeBuilderAmenities from "./tabs/RoomTypeBuilderAmenities"
import RoomTypeBuilderHousekeepingTypes from "./tabs/RoomTypeBuilderHousekeepingTypes"
import RoomTypeBuilderImageGroup from "./tabs/RoomTypeBuilderImageGroup"
import RoomTypeBuilderIncidentalDeposit from "./tabs/RoomTypeBuilderIncidentalDeposit"
import RoomTypeBuilderPrice from "./tabs/RoomTypeBuilderPrice"
import RoomTypeBuilderPrices from "./tabs/RoomTypeBuilderPrices"
import RoomTypeBuilderRoomGroups from "./tabs/RoomTypeBuilderRoomGroups"
import RoomTypeBuilderRooms from "./tabs/RoomTypeBuilderRooms"
import RoomTypeBuilderBedrooms from "./tabs/RoomTypeBuilderBedrooms"
import RoomTypeBuilderRates from "./tabs/RoomTypeBuilderRates"
import RoomTypeBuilderProperty from "./tabs/RoomTypeBuilderProperty"
import RoomTypeBuilderProducts from  "./tabs/RoomTypeBuilderProducts"
import RoomTypeBuilderChannelManagement from  "./tabs/RoomTypeBuilderChannelManagement"


class RoomTypeBuilderWorkspace extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <RoomTypeBuilderGeneral {...this.props} />
        <RoomTypeBuilderAmenities {...this.props} />
        <RoomTypeBuilderHousekeepingTypes {...this.props} />
        <RoomTypeBuilderImageGroup {...this.props} />
        <RoomTypeBuilderIncidentalDeposit {...this.props} />
        {/* <RoomTypeBuilderPrice {...this.props} /> */}
        <RoomTypeBuilderPrices {...this.props} />
        {this.props.type_of_booking == "room_group" ?
        <RoomTypeBuilderRoomGroups {...this.props} />
        :
        <RoomTypeBuilderRooms {...this.props} />

      }
        <RoomTypeBuilderBedrooms {...this.props} />
        <RoomTypeBuilderRates {...this.props} />
        <RoomTypeBuilderProducts {...this.props} />
        <RoomTypeBuilderChannelManagement {...this.props} />
        {/* <RoomTypeBuilderProperty {...this.props} /> */}
      </div>
    )
  }

};

export default RoomTypeBuilderWorkspace
